import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Center from 'react-center';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Agenda from './Agenda'

const theme = createMuiTheme({
    palette: {
        primary: {
            light: "#308CB0",
            main: "#60c1d8",
            dark: "#6B2574",
            contrastText: "#FFFFFF"
        },
        secondary: {
            light: "#a5c9a7",
            main: "#72BE76",
        }
    },
    typography: {
        useNextVariants: true,
        fontFamily: [
            'Montserrat',
            'Montserrat Bold',
            'Montserrat Regular',
            'Raleway',
            'Raleway Semibold',
            'Raleway Regular',
        ].join(','),
    }
});

const styles = theme => ({
    headerLeft:{
        marginTop: -200,
        marginRight: 50,
        marginLeft: 30,
        color: "#ffffff",
        fontFamily: 'Montserrat'
    },
    headerButton: {
        borderRadius:0,
        borderColor: "#ffffff",
        color: "#ffffff",
        flex: 1,
        width: '100%',
        borderWidth: 3
    },
    headerText: {
        fontFamily: 'Montserrat'
    },
    standardTextHeader:{
        fontFamily: 'Montserrat'
    },
    bodyStyle:{
        fontFamily: 'Raleway',
        color: "#1D1B39",
        paddingTop: 50,
        paddingBottom: 50,
        paddingRight: "10%",
        paddingLeft: "10%",
        fontSize: 20
    },
    responsiveImage:{
        width: '100%',
        maxWidth: 390,
        height: 'auto',
    },
    mainImage:{
        width: '100%',
        height: 'auto',
    },
    responsiveSignUp:{
        backgroundColor: "#cccccc",
        padding:25
    },
    responsiveGridCell: {
        textAlign: 'left'
    },
    footerDiv:{
        fontFamily: 'Raleway',
        backgroundColor:"#505053",
        color: "#ffffff",
        width: '100%',
        paddingTop: 15,
        paddingBottom: 15
    },
    footerMap:{
        width: '90%',
        maxWidth: 600,
        height: 450,
        border:0
    },
    footerGridLeft:{
        paddingLeft: "10%"
    },
    footerGrid:{
        width: '100%'
    },
    footerGridRight:{
        paddingLeft: "10%"
    },
    topDiv:{
        marginBottom: -3
    },
    fortellisHref: {
        color: 'inherit',
        fontFamily: 'Montserrat',
    },
    regClosedButton: {
        margin: 8,
        padding: 5,
        width: 160,
        color: '#FFFFFF',
        backgroundColor: "#60c1d8",
        borderRadius: 4,
        textTransform: 'uppercase',
        verticalAlign: 'middle',
    },
});


class App extends Component {
    // const { classes } = props;

    openHackerEarth(){
        window.open("https://fortellis.hackerearth.com/campaign/1/about", "_blank")
    }

    render() {
        const { classes } = this.props;
        return (
            <MuiThemeProvider theme={theme}>
                <div className="App">
                    <div className={classes.topDiv}>
                        <img src={require('./images/DevDay_Hackerearth[1].jpg')} className={classes.mainImage} alt="Fortellis (dev)day"/>
                        <Hidden mdDown>
                            <div className={classes.headerLeft}>
                                <h1 className={classes.headerText}><a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> (dev)day</h1>
                                <h3 className={classes.headerText}>Spring 2019 | Location TBD</h3>
                                {/*<h2 className={classes.headerText}>Registration is Full</h2>*/}

                            </div>
                        </Hidden>
                    </div>

                    <Hidden only={['lg', 'xl']} >
                        <Grid container spacing={8} className={classes.responsiveSignUp}>
                            <Grid item lg={12} xl={12} md={12} sm={12} xs={12} className={classes.responsiveGridCell}>
                                <h1 className={classes.headerText}><a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> (dev)day</h1>
                                <h3 className={classes.headerText}>Spring 2019 | Location TBD</h3>
                                {/*<Button onClick={this.openHackerEarth} className={classes.headerButtonStandard} variant="contained" color="primary">*/}
                                    {/*Register Now*/}
                                {/*</Button>*/}
                                {/*<h2 className={classes.headerText}>Registration is Full</h2>*/}
                            </Grid>
                        </Grid>
                    </Hidden>
                    {/*<div className={classes.bodyStyle}>*/}
                        {/*<Center>*/}
                            {/*<h1 className={classes.standardTextHeader}>About <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> Developer Day</h1>*/}
                        {/*</Center>*/}
                        {/*<p>*/}
                            {/*Join us January 24 at the Park Central Hotel, meeting room Franciscan II, to learn how to develop*/}
                            {/*on the <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> platform, speak with <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> devs, discover upcoming APIs and collaborate with*/}
                            {/*others who are re-inventing technology. Our lead developers will be on site to answer questions,*/}
                            {/*share innovations and provide a sneak peek into the platform's roadmap. The second half of the day*/}
                            {/*is focused on live coding: bring your use cases, bring your ideas, bring your APIs and solutions*/}
                            {/*and we will code alongside you to get your <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> development to the next step. This event is*/}
                            {/*open to all developers, but space is Limited. Snacks, drinks and Wi-Fi are provided; just bring*/}
                            {/*your computer, questions and ideas.*/}
                        {/*</p>*/}
                    {/*</div>*/}
                    <div>
                        <br/>
                        <br/>
                        <br/>
                    </div>
                    <Grid container spacing={8} className={classes.responsiveSignUp}>
                        <Grid item lg={12} xl={12} md={12} sm={12} xs={12} className={classes.responsiveGridCell}>
                            <Center>
                                <h1 className={classes.standardTextHeader}>Information about the next <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> (dev)day coming soon.</h1><br/>
                            </Center>
                            <Center>

                                <h3 className={classes.headerText}>
                                    {/*<Center>Registration is full.</Center>*/}
                                    <br/>Please be sure to stay up to date on the latest with Fortellis at <a href="https://fortellis.io/" target="_blank">fortellis.io</a> or reach out to our <a href="mailto:Fortellis Team <info@fortellis.io>">Fortellis team</a> about other upcoming events with Fortellis.
                                    {/*Once you register above for HackerEarth, you are automatically registered for the (dev)day event in San Francisco. Click <a href="https://fortellis.hackerearth.com/campaign/1/about" target="_blank">register</a> to sign up.*/}
                                </h3>
                            </Center>
                            <Center>
                                <h2 className={classes.headerText}>Do you have questions about (dev)day? <a href="mailto:Fortellis Team <info@fortellis.io>">Email the Fortellis team</a>.</h2>
                            </Center>
                        </Grid>
                    </Grid>
                    {/*<Agenda />*/}
                    <Grid container spacing={8} className={classes.responsiveSignUp}>
                        <Grid item lg={12} xl={12} md={12} sm={12} xs={12} className={classes.responsiveGridCell}>
                            <Center>
                                <h1 className={classes.headerText}><a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> (dev)day</h1>
                            </Center>
                            <Center>
                                <h3 className={classes.headerText}>Spring 2019 | Location TBD</h3>
                            </Center>
                            <Center>
                                {/*<h2 className={classes.headerText}>Registration is Full</h2>*/}
                            </Center>
                        </Grid>
                    </Grid>
                    {/*<div className={classes.footerDiv}>*/}
                        {/*<Grid container spacing={24} className={classes.footerGrid}>*/}
                            {/*<Grid item xs={12} sm={12} md={6} lg={6} xl={6} >*/}
                                {/*<div className={classes.footerGridLeft}>*/}
                                    {/*<h2 className={classes.standardTextHeader}>VENUE INFO</h2>*/}
                                    {/*<h4 className={classes.standardTextHeader}>Park Central Hotel | <small>Franciscan II meeting room</small></h4>*/}
                                    {/*<div>*/}
                                        {/*<p>50 3rd St<br/>*/}
                                        {/*San Francisco, CA 94103</p>*/}
                                        {/*<p>&nbsp;</p>*/}
                                        {/*<p>*/}
                                            {/*We will be in the Franciscan II meeting room for the developer day event.<br/>*/}
                                            {/*For more information about the hotel, visit<br/>*/}
                                            {/*<a target="_blank" rel="noopener noreferrer" href="https://www.marriott.com/hotels/travel/sfopc-the-park-central-san-francisco?program=spg" id="undefined_TS_SideMediaWithCopy_2_2_0">The Park Central San Francisco</a>*/}
                                        {/*</p>*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                            {/*</Grid>*/}
                            {/*<Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.footerGridRight} >*/}
                                {/*<Center>*/}
                                    {/*<iframe title="location_map" className={classes.footerMap} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.1473179848786!2d-122.40528528468198!3d37.78658717975728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80858087e00f4c11%3A0x958edf7e8594c21f!2sThe+Park+Central+San+Francisco!5e0!3m2!1sen!2sus!4v1544134559123" frameBorder="0" allowFullScreen></iframe>*/}
                                {/*</Center>*/}
                            {/*</Grid>*/}
                        {/*</Grid>*/}
                    {/*</div>*/}
                </div>
            </MuiThemeProvider>
        );
    }
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(App);
